import * as i0 from '@angular/core';
import { forwardRef, Component, ChangeDetectionStrategy, Input, HostBinding, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import * as i1 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';

class FsWizardComponent {
    constructor(_cdRef) {
        this._cdRef = _cdRef;
        this.config = { steps: [] };
        this.orientation = 'horizontal';
        this.classFsWizard = true;
        this._onTouched = () => { };
        this._onChange = (value) => { };
    }
    get classVertical() {
        return this.orientation === 'vertical';
    }
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    writeValue(value) {
        this.selected = value;
        this._cdRef.detectChanges();
    }
    next() {
        let index = this.getStepIndex();
        if (index >= 0) {
            index++;
            const next = this.config.steps[index];
            if (next) {
                this.stepIndex = index;
                this.select(next.value);
            }
        }
    }
    back() {
        this.stepIndex = this.getStepIndex();
        if (this.stepIndex > 0) {
            const back = this.config.steps[this.stepIndex - 1];
            if (back) {
                this.select(back.value);
            }
        }
    }
    first() {
        this.stepIndex = 0;
        const step = this.config.steps[this.stepIndex];
        if (step) {
            this.select(step.value);
        }
    }
    last() {
        this.stepIndex = this.config.steps.length - 1;
        const step = this.config.steps[this.stepIndex];
        if (step) {
            this.select(step.value);
        }
    }
    select(name) {
        this.selected = name;
        this._cdRef.detectChanges();
        this._onChange(this.selected);
    }
    getStepIndex() {
        return this.config.steps.findIndex((item) => {
            return item.value === this.selected;
        });
    }
}
FsWizardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsWizardComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FsWizardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsWizardComponent, selector: "fs-wizard", inputs: { config: "config", orientation: "orientation" }, host: { properties: { "class.fs-wizard": "this.classFsWizard", "class.vertical": "this.classVertical" } }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FsWizardComponent),
            multi: true
        }
    ], ngImport: i0, template: "<div\n\t\tclass=\"step\"\n\t\t*ngFor=\"let step of config.steps; let i = index\"\n\t\t[ngClass]=\"{ selected: step.value===selected, past: i < stepIndex }\">\n\t<div class=\"step-wraper\">\n\t\t<div class=\"badge-wraper\">\n\t\t\t<div class=\"badge\">\n\t\t\t\t<div class=\"number\">{{ i + 1 }}</div>\n\t\t\t\t<mat-icon class=\"icon\">check</mat-icon>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"label\" *ngIf=\"step.label\">{{step.label}}</div>\n\t</div>\n</div>", styles: [":host{flex-direction:row;box-sizing:border-box;display:flex;position:relative}:host .step-wraper{display:flex;flex-direction:row;align-items:center}:host .step{flex:1 1 100%;max-width:100%;max-height:100%;box-sizing:border-box;white-space:nowrap;display:flex;align-items:center}:host .step.selected .number{color:#fff}:host .step.selected .label{font-weight:bold}:host .step:last-child{flex:0}:host .step.past .number{display:none}:host .step.past .icon{display:block}:host .step+.step:before{content:\"x\";color:transparent;position:relative;z-index:1;width:10px;background-color:#fff}:host .step .icon{display:none;color:#fff;transform:scale(.75)}:host .step .badge{width:25px;height:25px;display:flex;border-radius:50%;text-align:center;line-height:25px;z-index:1;position:relative;font-size:95%;background-color:#b5b5b5;color:#fff;align-items:center;justify-content:center}:host .label{background-color:#fff;padding:0 10px 0 6px;z-index:1;position:relative}:host.vertical .step{flex-direction:column;align-items:start}:host.vertical .step+.step:before{content:none;width:0}:host.vertical .step .step-wraper{display:flex;flex-direction:column;align-items:center}:host.vertical .step .step-wraper .badge-wraper{display:flex;justify-content:center;width:100%;z-index:2;background-color:#fff}:host.vertical:after{top:13px!important}:host:after{content:\".\";display:block;height:1px;width:100%;margin:auto;text-indent:-9999px;border-top:1px solid #efefef;position:absolute;left:0;top:50%}@media screen and (max-width: 599px){.step:not(.selected) .label{display:none}}\n"], components: [{ type: i1.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], directives: [{ type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsWizardComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-wizard',
                    templateUrl: 'wizard.component.html',
                    styleUrls: ['wizard.component.scss'],
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => FsWizardComponent),
                            multi: true
                        }
                    ],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { config: [{
                type: Input
            }], orientation: [{
                type: Input
            }], classFsWizard: [{
                type: HostBinding,
                args: ['class.fs-wizard']
            }], classVertical: [{
                type: HostBinding,
                args: ['class.vertical']
            }] } });

class FsWizardModule {
    static forRoot() {
        return {
            ngModule: FsWizardModule
        };
    }
}
FsWizardModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsWizardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FsWizardModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsWizardModule, declarations: [FsWizardComponent], imports: [CommonModule,
        MatIconModule], exports: [FsWizardComponent] });
FsWizardModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsWizardModule, imports: [[
            CommonModule,
            MatIconModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsWizardModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatIconModule,
                    ],
                    exports: [
                        FsWizardComponent,
                    ],
                    declarations: [
                        FsWizardComponent,
                    ],
                }]
        }] });

/*
 * Public API Surface of fs-menu
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FsWizardComponent, FsWizardModule };
